// extracted by mini-css-extract-plugin
export default {"main":"styles__main_____T2t","header":"styles__header___WGcas","inputs":"styles__inputs___rF83P","infoText":"styles__infoText___flcJN","button":"styles__button___WXBTQ"};